import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fatchBusinesses = createAsyncThunk(
  "businessType/fatchBusinesses",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/vendor-business-type/${data.type}?page=${data.page}&perPage=${data.perPage}&search=${data.search}&filter=${data.filter}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fatch data.");
    }
  }
);

export const addBusinessType = createAsyncThunk(
  "businessType/addBusinessType",
  async (formData, { rejectWithValue }) => {
    try {
      let url = "";
      if (formData.id) {
        url = `/${formData.id}`;
      }
      const response = await api.post('admin/vendor-business'+url, formData);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to add type.");
    }
  }
);

export const deleteBusinessType = createAsyncThunk(
  "businessType/deleteBusinessType",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.del(`admin/vendor-business/${id}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete type.");
    }
  }
);

export const changeBusinessStatus = createAsyncThunk(
  "businessType/changeBusinessStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await api.post(`admin/vendor-business/${id}/status`, { status });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete type.");
    }
  }
);

const businessTypeSlice = createSlice({
  name: "businessType",
  initialState: {
    list_business_type: [],
    selected: null,
    loading: false,
    status: "idle",
    list_loading:false,
  },
  reducers: {
    setSelectedBusinessType(state, action) {
      state.selected = action.payload;
    },
    unsetSelectedBusiness(state) {
      state.selected = null;
    },
    resetStatus(state) {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fatchBusinesses.pending, (state) => {
      state.list_loading = true;
    })
    .addCase(fatchBusinesses.fulfilled, (state, action) => {
      state.list_business_type = action.payload;
      state.list_loading = false;
    })
    .addCase(fatchBusinesses.rejected, (state, action) => {
      state.list_loading = false;
    })
    .addCase(deleteBusinessType.pending, (state) => {
      state.loading = true;
    })
    .addCase(deleteBusinessType.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(deleteBusinessType.rejected, (state, action) => {
      state.loading = false;
    })
    .addCase(addBusinessType.pending, (state) => {
      state.loading = true;
    })
    .addCase(addBusinessType.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(addBusinessType.rejected, (state, action) => {
      state.loading = false;
    })
    .addCase(changeBusinessStatus.pending, (state) => {
      state.loading = true;
    })
    .addCase(changeBusinessStatus.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(changeBusinessStatus.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {setSelectedBusinessType, unsetSelectedBusiness, resetStatus} = businessTypeSlice.actions;
export default businessTypeSlice.reducer;